import { render, staticRenderFns } from "./dataSettings.vue?vue&type=template&id=6d9e8c7f&scoped=true"
import script from "./dataSettings.vue?vue&type=script&lang=js"
export * from "./dataSettings.vue?vue&type=script&lang=js"
import style0 from "./dataSettings.vue?vue&type=style&index=0&id=6d9e8c7f&prod&lang=scss"
import style1 from "./dataSettings.vue?vue&type=style&index=1&id=6d9e8c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9e8c7f",
  null
  
)

export default component.exports